import React from 'react';
import VIDABOO_CONSTANTS from '../../../config/consts';

// todo : ENABLE_PAY_PER_LEAD

const SHORTCUTS = {
  SETTINGS_SHORTCUT: 'SETTINGS_SHORTCUT',
};

const SHORTCUTS_MENU_ITEMS = {
  //SETTINGS_SHORTCUT
  SHORTCUT_CHAT: 'SHORTCUT_CHAT',
  SHORTCUT_VIDEO: 'SHORTCUT_VIDEO',
  SHORTCUT_SCHEDULE: 'SHORTCUT_SCHEDULE',
};

const BUCKETS = {
  WIDGET_CENTER: 'WIDGET_CENTER',
  PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
  ACCOUNTS: 'ACCOUNTS',
  ROOT: 'ROOT',
};

const BUCKET_MENU_ITEMS = {
  //HOME:
  HOME: 'HOME',
  //WIDGET_CENTER
  MANAGE_WIDGETS: 'MANAGE_WIDGETS',
  SETUP_AND_INSTALLATION: 'SETUP_AND_INSTALLATION',
  // SETUP_AND_INSTALLATION[COMMUNICATION]
  APPEARANCE: 'APPEARANCE',
  ACTIVE_CHANNELS: 'ACTIVE_CHANNELS',
  IN_ACTIVE_CHANNELS: 'IN_ACTIVE_CHANNELS',
  ACCOUNT_DEFAULTS: 'ACCOUNT_DEFAULTS',
  //PERSONAL_SETTINGS
  PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
  NOTIFICATIONS: 'NOTIFICATIONS',
  PERSONAL_SETTINGS_INTEGRATIONS: 'PERSONAL_SETTINGS_INTEGRATIONS',
  SECURITY: 'SECURITY',
  BACKOFFICE_SETTINGS: 'BACKOFFICE_SETTINGS',
  //ACCOUNT
  ACCOUNT_INFO: 'ACCOUNT_INFO',
  BILLING: 'BILLING',
  USERS: 'USERS',
  PARTNERSHIPS: 'PARTNERSHIPS',
  ADVANCED: 'ADVANCED',
};

const BUCKET_MENU_ITEMS_TYPES = {
  BUCKET_MENU: 'BUCKET_MENU',
  DROPDOWN_MENU: 'DROPDOWN_MENU',
  DROPDOWN_TAB: 'DROPDOWN_TAB',
  SUB_MENU: 'SUB_MENU',
  TAB: 'TAB',
  SHORTCUTS_MENU: 'SHORTCUTS_MENU',
  SHORTCUT: 'SHORTCUT',
};

const BUCKET_SUB_MENU_ITEMS = {
  //WIDGET_CENTER -> BUCKET_MENU_ITEMS[SETUP_AND_INSTALLATION]
  AGENTS_LIST: 'AGENTS_LIST',
  //BUCKET_MENU_ITEMS[SETUP_AND_INSTALLATION][GENERAL_INFO]
  GENERAL_INFO: 'GENERAL_INFO',
  GENERAL_INFO_WIDGET: 'GENERAL_INFO_WIDGET',
  GENERAL_INFO_AGENT: 'GENERAL_INFO_AGENT',
  CONTROL: 'CONTROL',
  //BUCKET_MENU_ITEMS[SETUP_AND_INSTALLATION][CONTROL]
  CONTROL_GENERAL: 'CONTROL_GENERAL',
  CONTROL_AGENT: 'CONTROL_AGENT',
  //BUCKET_MENU_ITEMS[SETUP_AND_INSTALLATION][CUSTOMIZATIONS]
  CUSTOMIZATIONS: 'CUSTOMIZATIONS',
  CUSTOMIZATIONS_WIDGET: 'CUSTOMIZATIONS_WIDGET',
  CUSTOMIZATIONS_TEAM: 'CUSTOMIZATIONS_TEAM',
  CUSTOMIZATIONS_AGENT: 'CUSTOMIZATIONS_AGENT',
  CUSTOMIZATIONS_EMAIL: 'CUSTOMIZATION_EMAIL',
  //COMMUNICATION -> BUCKET_MENU_ITEMS[COMMUNICATION]
  COMMUNICATION: 'COMMUNICATION',
  COMMUNICATION_AGENT: 'COMMUNICATION_AGENT',
  //COMMUNICATION -> BUCKET_MENU_ITEMS[COMMUNICATION][COMMUNICATION_AGENT][APPEARANCE]
  COMMUNICATION_APPEARANCE_ORDER: 'COMMUNICATION_APPEARANCE_ORDER',
  COMMUNICATION_APPEARANCE_ACTION_SELECTOR:
    'COMMUNICATION_APPEARANCE_ACTION_SELECTOR',
  //COMMUNICATION -> BUCKET_MENU_ITEMS[COMMUNICATION][COMMUNICATION_AGENT][ACTIVE_CHANNELS|IN_ACTIVE_CHANNELS]
  //Note: following COMMUNICATION Ids are in sync with VIDABOO_CONSTANTS.WIDGET_APP_TYPES, so can't be changed directly
  COMMUNICATION_TEXT_CHAT: 'COMMUNICATION_TEXT_CHAT',
  //COMMUNICATION -> BUCKET_MENU_ITEMS[COMMUNICATION][COMMUNICATION_AGENT][ACTIVE_CHANNELS|IN_ACTIVE_CHANNELS][TEXT_CHAT]
  COMMUNICATION_TEXT_CHAT_SETUP: 'COMMUNICATION_TEXT_CHAT_SETUP',
  COMMUNICATION_TEXT_CHAT_FORM: 'COMMUNICATION_TEXT_CHAT_FORM',
  COMMUNICATION_TEXT_CHAT_AUTOMATION: 'COMMUNICATION_TEXT_CHAT_AUTOMATION',
  COMMUNICATION_INFO_COLLECTOR: 'COMMUNICATION_INFO_COLLECTOR',
  //COMMUNICATION -> BUCKET_MENU_ITEMS[COMMUNICATION][COMMUNICATION_AGENT][ACTIVE_CHANNELS|IN_ACTIVE_CHANNELS][COMMUNICATION_INFO_COLLECTOR]
  COMMUNICATION_INFO_COLLECTOR_SETUP: 'COMMUNICATION_INFO_COLLECTOR_SETUP',
  COMMUNICATION_INFO_COLLECTOR_FORM: 'COMMUNICATION_INFO_COLLECTOR_FORM',
  COMMUNICATION_INFO_COLLECTOR_MONEY_TRANSFER:
    'COMMUNICATION_INFO_COLLECTOR_MONEY_TRANSFER',
  COMMUNICATION_WEBCALL: 'COMMUNICATION_WEBCALL',
  //COMMUNICATION -> BUCKET_MENU_ITEMS[COMMUNICATION][COMMUNICATION_AGENT][ACTIVE_CHANNELS|IN_ACTIVE_CHANNELS][COMMUNICATION_WEBCALL]
  COMMUNICATION_WEBCALL_SETUP: 'COMMUNICATION_WEBCALL_SETUP',
  COMMUNICATION_WEBCALL_FORM: 'COMMUNICATION_WEBCALL_FORM',
  COMMUNICATION_WEBCALL_MONEY_TRANSFER: 'COMMUNICATION_WEBCALL_MONEY_TRANSFER',
  COMMUNICATION_SCHEDULE_MEETING: 'COMMUNICATION_SCHEDULE_MEETING',
  //COMMUNICATION -> BUCKET_MENU_ITEMS[COMMUNICATION][COMMUNICATION_AGENT][ACTIVE_CHANNELS|IN_ACTIVE_CHANNELS][COMMUNICATION_SCHEDULE_MEETING]
  COMMUNICATION_SCHEDULE_MEETING_SETUP: 'COMMUNICATION_SCHEDULE_MEETING_SETUP',
  COMMUNICATION_SCHEDULE_MEETING_FORM: 'COMMUNICATION_SCHEDULE_MEETING_FORM',
  COMMUNICATION_SCHEDULE_MEETING_SETTINGS:
    'COMMUNICATION_SCHEDULE_MEETING_SETTINGS',
  COMMUNICATION_SCHEDULE_MONEY_TRANSFER:
    'COMMUNICATION_SCHEDULE_MONEY_TRANSFER',
  COMMUNICATION_WHATSAPP: 'COMMUNICATION_WHATSAPP',
  COMMUNICATION_FB_MESSENGER: 'COMMUNICATION_FB_MESSENGER',
  COMMUNICATION_CUSTOM_LINK: 'COMMUNICATION_CUSTOM_LINK',
  COMMUNICATION_PHONE_CALL: 'COMMUNICATION_PHONE_CALL',
  STYLING: 'STYLING',
  //BUCKET_MENU_ITEMS[SETUP_AND_INSTALLATION][STYLING]
  STYLING_WIDGET: 'STYLING_WIDGET',
  STYLING_TEAM: 'STYLING_TEAM',
  STYLING_AGENT: 'STYLING_AGENT',

  PAYMENT_GATEWAYS: 'PAYMENT_GATEWAYS',
  WIDGET_CENTER_INTEGRATIONS: 'WIDGET_CENTER_INTEGRATIONS',
  WIDGET_CENTER_INTEGRATIONS_TEAM: 'WIDGET_CENTER_INTEGRATIONS_TEAM',
  WIDGET_CENTER_INTEGRATIONS_AGENT: 'WIDGET_CENTER_INTEGRATIONS_AGENT',
  ADVANCED_FEATURES: 'ADVANCED_FEATURES',
  DYNAMIC_FORMS: 'DYNAMIC_FORMS',
  THREED_SENSE: 'THREED_SENSE',
  INSTALLATION: 'INSTALLATION',

  //BUCKET_MENU_ITEMS[SETUP_AND_INSTALLATION][AI_ASSISTANT]
  AI: 'AI',
  AI_SETTINGS: 'AI_SETTINGS',
  AI_SETTINGS_WIDGET: 'AI_SETTINGS_WIDGET',
  AI_SETTINGS_AGENT: 'AI_SETTINGS_AGENT',

  AI_KNOWLEDGE_BASE: 'AI_KNOWLEDGE_BASE',
  AI_BRAIN: 'AI_BRAIN',
  KB_RESOURCE_DOCUMENT: 'KB_RESOURCE_DOCUMENT',
  KB_RESOURCE_QA: 'KB_RESOURCE_QA',
  KB_RESOURCE_SCRAPING: 'KB_RESOURCE_SCRAPING',
  AI_BRAIN_SETTINGS: 'AI_BRAIN_SETTINGS',
  AI_BRAIN_MODEL_CONFIGURATION: 'AI_BRAIN_MODEL_CONFIGURATION',
  AI_ACTIONS: 'AI_ACTIONS',
  AI_BRAIN_HANDOFF: 'AI_BRAIN_HANDOFF',
  AI_MEETING_ACTIONS: 'AI_MEETING_ACTIONS',

  //WIDGET_CENTER -> BUCKET_MENU_ITEMS[ACCOUNT_DEFAULTS]
  PROFILE: 'PROFILE',
  ORDER: 'ORDER',

  //BILLING
  BILLING_MY_PLAN: 'BILLING_MY_PLAN',
  BILLING_ADDONS_AND_USAGE: 'BILLING_ADDONS_AND_USAGE',
  BILLING_INVOICES: 'BILLING_INVOICES',
};

const COMMUNICATION_PATH = 'widgetSetup/setUpInstallation/communication';

//NOTE : First tab in children needs to be of TAB type
const ROOT = {
  isViewable: true,
  type: BUCKET_MENU_ITEMS_TYPES.SUB_MENU,
  navMenuItemId: BUCKETS.ROOT,
  navText: 'Settings',
  urlKey: 'root',
  children: [
    //Home
    {
      isViewable: true,
      Icon: React.lazy(
        () =>
          import('../../../assets/svgComponents/LeftNavigationIcons/HomeIcon'),
      ),
      type: BUCKET_MENU_ITEMS_TYPES.TAB,
      navMenuItemId: BUCKET_MENU_ITEMS.HOME,
      navText: 'Settings home',
      urlKey: 'home',
    },
    //Widget setup & installation
    {
      isViewable: true,
      type: BUCKET_MENU_ITEMS_TYPES.BUCKET_MENU,
      navMenuItemId: BUCKETS.WIDGET_CENTER,
      navText: 'Widget setup and installation',
      urlKey: 'widgetSetup',
      children: [
        //Manage Widgets
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/ManageWidgetsIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.MANAGE_WIDGETS,
          navText: 'Manage teams',
          urlKey: 'manageWidget',
        },
        //Setup & installation
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/SetUpInstallationIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.SUB_MENU,
          navMenuItemId: BUCKET_MENU_ITEMS.SETUP_AND_INSTALLATION,
          navText: 'Setup & installation',
          urlKey: 'setUpInstallation',
          children: [
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/AgentsIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.AGENTS_LIST,
              navText: 'Agents list',
              urlKey: 'agentsList',
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/PersonalInformationIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.GENERAL_INFO,
              navText: 'General Info',
              urlKey: 'generalInfo',
              children: [
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.GENERAL_INFO_WIDGET,
                  navText: 'Widget view',
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'generalInfoWidgetView',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.GENERAL_INFO_AGENT,
                  navText: 'Agent view',
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                  urlKey: 'generalInfoAgentView',
                },
              ],
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/ManageWidgetsIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.SUB_MENU,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.COMMUNICATION,
              navText: 'Communication',
              urlKey: 'communication',
              children: [
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.BUCKET_MENU,
                  navMenuItemId: BUCKET_MENU_ITEMS.APPEARANCE,
                  navText: 'Appearance',
                  urlKey: 'appearance',
                  children: [
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/SortIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.TAB,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_APPEARANCE_ORDER,
                      navText: 'Order',
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'appearanceOrder',
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/ActionSelectorIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.TAB,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_APPEARANCE_ACTION_SELECTOR,
                      navText: 'Action Menu',
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'appearanceActionSelector',
                    },
                  ],
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.BUCKET_MENU,
                  navMenuItemId: BUCKET_MENU_ITEMS.ACTIVE_CHANNELS,
                  navText: 'Active Channels',
                  urlKey: 'activeChannels',
                  children: [
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/ChatIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_TEXT_CHAT,
                      navText: 'Chat',
                      urlKey: 'communicationTextChat',
                      children: [
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_TEXT_CHAT_SETUP,
                          navText: 'Tab setup',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'tabSetup',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_TEXT_CHAT_FORM,
                          navText: 'Pre-chat form',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'form',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_TEXT_CHAT_AUTOMATION,
                          navText: 'Automation',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'automation',
                        },
                      ],
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/VideoChatIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_WEBCALL,
                      navText: 'Video Chat',
                      urlKey: 'communicationWebcall',
                      children: [
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_WEBCALL_SETUP,
                          navText: 'Tab setup',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'tabSetup',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_WEBCALL_FORM,
                          navText: 'Pre-call form',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'form',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_WEBCALL_MONEY_TRANSFER,
                          navText: 'Money transfer',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'moneyTransfer',
                        },
                      ],
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/AppointmentIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_SCHEDULE_MEETING,
                      navText: 'Appointment',
                      urlKey: 'communicationScheduleMeeting',
                      children: [
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_SCHEDULE_MEETING_SETUP,
                          navText: 'Tab setup',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'tabSetup',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_SCHEDULE_MEETING_FORM,
                          navText: 'Booking form',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'form',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_SCHEDULE_MEETING_SETTINGS,
                          navText: 'Booking settings',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'settings',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_SCHEDULE_MONEY_TRANSFER,
                          navText: 'Money transfer',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'moneyTransfer',
                        },
                      ],
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/WhatsAppIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.TAB,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_WHATSAPP,
                      navText: 'WhatsApp',
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'communicationWhatsApp',
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/MessengerIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.TAB,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_FB_MESSENGER,
                      navText: 'Messenger',
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'communicationMessenger',
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/CustomLinkIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.TAB,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_CUSTOM_LINK,
                      navText: 'Custom link',
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'communicationLink',
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/PhoneIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.TAB,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_PHONE_CALL,
                      navText: 'Phone',
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'communicationPhone',
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/ContactFormIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
                      navMenuItemId:
                        BUCKET_SUB_MENU_ITEMS.COMMUNICATION_INFO_COLLECTOR,
                      navText: 'Contact form',
                      urlKey: 'communicationContactForm',
                      children: [
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_INFO_COLLECTOR_SETUP,
                          navText: 'Tab setup',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'tabSetup',
                        },
                        {
                          isViewable: true,
                          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                          navMenuItemId:
                            BUCKET_SUB_MENU_ITEMS.COMMUNICATION_INFO_COLLECTOR_FORM,
                          navText: 'Form design',
                          tabMode:
                            VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                          urlKey: 'form',
                        },
                        // todo : ENABLE_PAY_PER_LEAD : uncomment this
                        // {
                        //   isViewable: true,
                        //   pillType: VIDABOO_CONSTANTS.PILL_TYPES.BETA,
                        //   type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                        //   navMenuItemId:
                        //     BUCKET_SUB_MENU_ITEMS.COMMUNICATION_INFO_COLLECTOR_MONEY_TRANSFER,
                        //   navText: 'Money transfer',
                        //   tabMode:
                        //     VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                        //   urlKey: 'moneyTransfer',
                        // },
                      ],
                    },
                  ],
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.BUCKET_MENU,
                  navMenuItemId: BUCKET_MENU_ITEMS.IN_ACTIVE_CHANNELS,
                  navText: 'Inactive Channels',
                  urlKey: 'inActiveChannels',
                  children: [],
                },
              ],
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/AiAssistantIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.SUB_MENU,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI,
              navText: VIDABOO_CONSTANTS.AI_ASSISTANT_NAME + ' Assistant',
              pillType: VIDABOO_CONSTANTS.PILL_TYPES.BETA,
              urlKey: 'aiAssistant',
              children: [
                {
                  isViewable: true,
                  Icon: React.lazy(
                    () =>
                      import(
                        '../../../assets/svgComponents/LeftNavigationIcons/AiAssistantSettingsIcon'
                      ),
                  ),
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_SETTINGS,
                  navText: 'Settings',
                  urlKey: 'aiSettings',
                  children: [
                    {
                      isViewable: true,
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                      navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_SETTINGS_WIDGET,
                      navText: 'Widget',
                      urlKey: 'aiSettingsWidget',
                    },
                    {
                      isViewable: true,
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                      navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_SETTINGS_AGENT,
                      navText: 'Agent',
                      supportedBackOfficeConfigurations: [
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .ADMIN_SINGLE_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .ADMIN_MULTI_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .NON_ADMIN_SINGLE_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .NON_ADMIN_MULTI_MODE,
                      ],
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'aiSettingsAgent',
                    },
                  ],
                },
                {
                  isViewable: true,
                  Icon: React.lazy(
                    () =>
                      import(
                        '../../../assets/svgComponents/LeftNavigationIcons/AiKnowledgeBaseIcon'
                      ),
                  ),
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_KNOWLEDGE_BASE,
                  navText: 'AI Knowledge base',
                  urlKey: 'aiKnowledgeBase',
                  children: [
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/AiWebsiteScrapingIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                      navMenuItemId: BUCKET_SUB_MENU_ITEMS.KB_RESOURCE_SCRAPING,
                      navText: 'Website scraping',
                      urlKey: 'kbResourceScraping',
                    },
                    {
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/AiUploadDocumentsIcon'
                          ),
                      ),
                      isViewable: true,
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                      navMenuItemId: BUCKET_SUB_MENU_ITEMS.KB_RESOURCE_DOCUMENT,
                      navText: 'Upload documents',
                      urlKey: 'kbResourceDocument',
                    },
                    {
                      isViewable: true,
                      Icon: React.lazy(
                        () =>
                          import(
                            '../../../assets/svgComponents/LeftNavigationIcons/AiQnAIcon'
                          ),
                      ),
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                      navMenuItemId: BUCKET_SUB_MENU_ITEMS.KB_RESOURCE_QA,
                      navText: 'QA',
                      urlKey: 'kbResourceQA',
                    },
                  ],
                },
                // {
                //   isViewable: true,
                //   Icon: AiBrainIcon,
                //   type: BUCKET_MENU_ITEMS_TYPES.TAB,
                //   navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_BRAIN,
                //   navText: 'AI Brain',
                //   urlKey: 'aiBrain',
                // },
                {
                  isViewable: true,
                  Icon: React.lazy(
                    () =>
                      import(
                        '../../../assets/svgComponents/LeftNavigationIcons/AiBrainIcon'
                      ),
                  ),
                  type: BUCKET_MENU_ITEMS_TYPES.TAB,
                  navMenuItemId:
                    BUCKET_SUB_MENU_ITEMS.AI_BRAIN_MODEL_CONFIGURATION,
                  navText: 'Brain IQ',
                  urlKey: 'aiBrainModelConfiguration',
                },
                {
                  isViewable: true,
                  Icon: React.lazy(
                    () =>
                      import(
                        '../../../assets/svgComponents/LeftNavigationIcons/AiBrainPersonality'
                      ),
                  ),
                  type: BUCKET_MENU_ITEMS_TYPES.TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_BRAIN_SETTINGS,
                  navText: 'Personality',
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                  urlKey: 'aiBrainSettings',
                },
                {
                  isViewable: true,
                  Icon: React.lazy(
                    () =>
                      import(
                        '../../../assets/svgComponents/LeftNavigationIcons/AiBrainHandoff'
                      ),
                  ),
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_ACTIONS,
                  navText: 'AI Actions',
                  urlKey: 'aiActions',
                  children: [
                    {
                      isViewable: true,
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                      navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_BRAIN_HANDOFF,
                      navText: 'Chat actions',
                      supportedBackOfficeConfigurations: [
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .ADMIN_SINGLE_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .ADMIN_MULTI_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .NON_ADMIN_SINGLE_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .NON_ADMIN_MULTI_MODE,
                      ],
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'aiBrainHandoff',
                    },
                    {
                      isViewable: true,
                      type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                      navMenuItemId: BUCKET_SUB_MENU_ITEMS.AI_MEETING_ACTIONS,
                      navText: 'Meeting actions',
                      supportedBackOfficeConfigurations: [
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .ADMIN_SINGLE_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .ADMIN_MULTI_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .NON_ADMIN_SINGLE_MODE,
                        VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                          .NON_ADMIN_MULTI_MODE,
                      ],
                      tabMode:
                        VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                      urlKey: 'aiMeetingActions',
                    },
                  ],
                },
              ],
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/StylingIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.STYLING,
              navText: 'Styling',
              urlKey: 'styling',
              children: [
                {
                  isViewable: true,
                  pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.STYLING_WIDGET,
                  navText: 'Widget',
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_SINGLE_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'stylingWidget',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.STYLING_TEAM,
                  navText: 'Team list',
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'stylingTeam',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.STYLING_AGENT,
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                  navText: 'Agent view',
                  urlKey: 'stylingAgent',
                },
              ],
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/CustomizationsIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.CUSTOMIZATIONS,
              navText: 'Customer experience',
              pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
              urlKey: 'customizations',
              children: [
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.CUSTOMIZATIONS_WIDGET,
                  navText: 'Widget',
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'customizationsWidget',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.CUSTOMIZATIONS_TEAM,
                  navText: 'Team',
                  pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'customizationsTeam',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.CUSTOMIZATIONS_AGENT,
                  navText: 'Agent',
                  pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                  urlKey: 'customizationsAgent',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.CUSTOMIZATIONS_EMAIL,
                  navText: 'Email customization',
                  pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'customizationsEmail',
                },
              ],
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/MoneyTransferIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.PAYMENT_GATEWAYS,
              navText: 'Payment Gateways',
              urlKey: 'paymentGateways',
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/IntegrationsIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.WIDGET_CENTER_INTEGRATIONS,
              navText: 'Integrations',
              pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
              urlKey: 'integrations',
              children: [
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId:
                    BUCKET_SUB_MENU_ITEMS.WIDGET_CENTER_INTEGRATIONS_TEAM,
                  navText: 'Team',
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'integrationsTeam',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId:
                    BUCKET_SUB_MENU_ITEMS.WIDGET_CENTER_INTEGRATIONS_AGENT,
                  navText: 'Agent',
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                  urlKey: 'integrationsAgent',
                },
              ],
            },
            // {
            //   isViewable: true,
            //   Icon: HeaderV2Icons.ChatCenterIcon,
            //   type: BUCKET_MENU_ITEMS_TYPES.TAB,
            //   navMenuItemId: BUCKET_SUB_MENU_ITEMS.ADVANCED_FEATURES,
            //   navText: 'Advanced Features',
            //   urlKey: 'advancedFeatures',
            // },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/DynamicFormIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.DYNAMIC_FORMS,
              navText: 'Dynamic forms',
              urlKey: 'dynamicForms',
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/ThreedIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.THREED_SENSE,
              navText: '3D Sense',
              urlKey: 'threedSense',
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/ControlIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.CONTROL,
              navText: 'Control',
              pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
              urlKey: 'control',
              children: [
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.CONTROL_GENERAL,
                  navText: 'Widget',
                  pillType: VIDABOO_CONSTANTS.PILL_TYPES.NEW,
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
                  urlKey: 'controlGeneral',
                },
                {
                  isViewable: true,
                  type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
                  navMenuItemId: BUCKET_SUB_MENU_ITEMS.CONTROL_AGENT,
                  navText: 'Agent',
                  supportedBackOfficeConfigurations: [
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION.ADMIN_MULTI_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_SINGLE_MODE,
                    VIDABOO_CONSTANTS.BACKOFFICE_CONFIGURATION
                      .NON_ADMIN_MULTI_MODE,
                  ],
                  tabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
                  urlKey: 'controlAgent',
                },
              ],
            },
            {
              isViewable: true,
              Icon: React.lazy(
                () =>
                  import(
                    '../../../assets/svgComponents/LeftNavigationIcons/InstallationCodeIcon'
                  ),
              ),
              type: BUCKET_MENU_ITEMS_TYPES.TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.INSTALLATION,
              navText: 'Installation',
              urlKey: 'installation',
            },
          ],
        },
        //Account defaults
        // {
        //   isViewable: true,
        //   type: BUCKET_MENU_ITEMS_TYPES.SUB_MENU,
        //   navMenuItemId: BUCKET_MENU_ITEMS.ACCOUNT_DEFAULTS,
        //   navText: 'Account defaults',
        //   urlKey: 'accountDefaults',
        //   children: [
        //     {
        //       isViewable: true,
        //       Icon: HeaderV2Icons.ChatCenterIcon,
        //       type: BUCKET_MENU_ITEMS_TYPES.TAB,
        //       navMenuItemId: BUCKET_SUB_MENU_ITEMS.PROFILE,
        //       navText: 'Profile',
        //       urlKey: 'profile',
        //     },
        //   ],
        // },
      ],
    },
    //Personal Settings
    {
      isViewable: true,
      type: BUCKET_MENU_ITEMS_TYPES.BUCKET_MENU,
      navMenuItemId: BUCKETS.PERSONAL_SETTINGS,
      navText: 'Personal Settings',
      urlKey: 'personalSettings',
      children: [
        //Personal Information
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/PersonalInformationIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.PERSONAL_INFORMATION,
          navText: 'Personal Information',
          urlKey: 'personalInformation',
        },
        //Notifications
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/NotificationsIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.NOTIFICATIONS,
          navText: 'Notifications',
          urlKey: 'notifications',
        },
        //Integrations
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/IntegrationsIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.PERSONAL_SETTINGS_INTEGRATIONS,
          navText: 'Integrations',
          urlKey: 'integrations',
        },
        //Security
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/SecurityIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.SECURITY,
          navText: 'Security and privacy',
          urlKey: 'security',
        },
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/BackofficeSettingsIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.BACKOFFICE_SETTINGS,
          navText: 'Backoffice Settings',
          urlKey: 'backOfficeSettings',
        },
      ],
    },
    //Account Settings
    {
      isViewable: true,
      type: BUCKET_MENU_ITEMS_TYPES.BUCKET_MENU,
      navMenuItemId: BUCKETS.ACCOUNTS,
      navText: 'Account Settings',
      urlKey: 'accountSettings',
      children: [
        //Account info
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/AccountInfoIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.ACCOUNT_INFO,
          navText: 'Account info',
          urlKey: 'accountInfo',
        },
        //Billing
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/BillingIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_MENU,
          navMenuItemId: BUCKET_MENU_ITEMS.BILLING,
          navText: 'Billing',
          urlKey: 'billing',
          children: [
            //MyPlan
            {
              isViewable: true,
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.BILLING_MY_PLAN,
              navText: 'My Plan',
              urlKey: 'billingMyPlan',
            },
            //Addons and usage
            {
              isViewable: true,
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.BILLING_ADDONS_AND_USAGE,
              navText: 'Addons and usage',
              urlKey: 'billingAddonsAndUsage',
            },
            //Invoices
            {
              isViewable: true,
              type: BUCKET_MENU_ITEMS_TYPES.DROPDOWN_TAB,
              navMenuItemId: BUCKET_SUB_MENU_ITEMS.BILLING_INVOICES,
              navText: 'Invoices',
              urlKey: 'billingInvoices',
            },
          ],
        },
        //Users
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/UsersIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.USERS,
          navText: 'Users',
          urlKey: 'users',
        },

        //Advanced
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/AdvancedIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.ADVANCED,
          navText: 'Advanced',
          urlKey: 'advanced',
        },
        //Partnerships
        {
          isViewable: true,
          Icon: React.lazy(
            () =>
              import(
                '../../../assets/svgComponents/LeftNavigationIcons/PartnershipsIcon'
              ),
          ),
          type: BUCKET_MENU_ITEMS_TYPES.TAB,
          navMenuItemId: BUCKET_MENU_ITEMS.PARTNERSHIPS,
          navText: 'Partnerships',
          urlKey: 'partnerships',
        },
      ],
    },
    //Settings Shortcuts
    {
      isViewable: true,
      type: BUCKET_MENU_ITEMS_TYPES.SHORTCUTS_MENU,
      navMenuItemId: SHORTCUTS.SETTINGS_SHORTCUT,
      navText: 'Settings Shortcuts',
      urlKey: 'settingsShortcuts',
      children: [
        //Chat
        {
          isViewable: true,
          type: BUCKET_MENU_ITEMS_TYPES.SHORTCUT,
          navMenuItemId: SHORTCUTS_MENU_ITEMS.SHORTCUT_CHAT,
          navText: 'Chat settings',
          urlKey: 'shortcutChat',
        },
        //Video
        {
          isViewable: true,
          type: BUCKET_MENU_ITEMS_TYPES.SHORTCUT,
          navMenuItemId: SHORTCUTS_MENU_ITEMS.SHORTCUT_VIDEO,
          navText: 'Videochat settings',
          urlKey: 'shortcutVideo',
        },
        //Schedule
        {
          isViewable: true,
          type: BUCKET_MENU_ITEMS_TYPES.SHORTCUT,
          navMenuItemId: SHORTCUTS_MENU_ITEMS.SHORTCUT_SCHEDULE,
          navText: 'Schedule settings',
          urlKey: 'shortcutSchedule',
        },
      ],
    },
  ],
};

export {
  ROOT,
  BUCKETS,
  BUCKET_MENU_ITEMS,
  BUCKET_MENU_ITEMS_TYPES,
  BUCKET_SUB_MENU_ITEMS,
  COMMUNICATION_PATH,
  SHORTCUTS,
  SHORTCUTS_MENU_ITEMS,
};
